import BadgeSmall from "./BadgeSmall";

export default BadgeSmall;